import React, { useState } from 'react';
import { Table, TableData } from '../common/Table';
import Select from 'react-select';

type Props = {
    leaderboards: Leaderboard[];
    onChangeDropdown: (val: Leaderboard) => void;
    selectedLeaderboard: Leaderboard;
};

export type Leaderboard = {
    name: string;
    infoTitle: string;
    infoContents: string;
    dropdownName: string;
    tableData: TableData;
};

export const LeaderboardCard: React.FC<Props> = ({ leaderboards, onChangeDropdown, selectedLeaderboard }) => {
    const [selectedIndex, setSelectedIndex] = useState<number>(0);

    const leaderboardOptions = leaderboards.map((leaderboard, index) => ({
        label: leaderboard.dropdownName,
        value: index,
    }));

    return (
        <div className="leaderboard-card">
            <div className="leaderboard-selection-container">
                <h2 className="leaderboard-title">{selectedLeaderboard.name}</h2>
                <div className="select-field-container">
                    <Select
                        className="select-container"
                        classNamePrefix={`select`}
                        isMulti={false}
                        options={leaderboardOptions}
                        isClearable={false}
                        isDisabled={false}
                        value={leaderboardOptions[selectedIndex]}
                        onChange={(val) => {
                            setSelectedIndex(val.value);
                            onChangeDropdown(leaderboards[val.value]);
                        }}
                    />
                </div>
            </div>
            <Table tableData={selectedLeaderboard.tableData} />
        </div>
    );
};
